export default {
  options: {
    controls: [],
    interactions: {
      // Evita que se pueda hacer movimiento sobre el mapa
      dragPan: true,
      shiftDragZoom: false,
      altShiftDragRotate: false,
    },
  },
  minZoom: 4,
  maxZoom: 13,
  projection: 'EPSG:3857',
  maps: [],
  overMaps: [],
  minimapMaps: [],
  layersGroup: [],
  maxSizePolygonRequest: null,
  warningSizePolygonRequest: null,
  pdf: {
    zoom: 18,
    height: 400,
    width: 600,
  },
};
